(function ($) {
    'use strict';

    $.fn.activateSimpleStub = function () {
        var $self = $(this);
        var $block = $self.find('.js-stub-block');
        var $calculateButton = $self.find('.js-stub-calculate-button');
        var widthForInit = 768;
        var $itemsForStub;

        var findItems = function (index) {
            $itemsForStub = $block.eq(index).find('.js-stub-wrapper');
        };

        var activateStub = function () {
            $itemsForStub.each(function (index, item) {
                var $self = $(item);
                var $name = $self.find('.js-stub-name');
                var $stub = $self.find('.js-stub-item');
                var wrapperWidth = $self.width();
                var nameWidth = $name.width();
                    var timeOut = setInterval(function () {
                        if (wrapperWidth > 0) {
                            nameWidth = $name.width();
                            if (nameWidth > wrapperWidth) {
                                $stub.addClass('active');
                            }
                            clearInterval(timeOut);
                        } else {
                            wrapperWidth = $self.width();
                        }
                    }, 200);
            });
        };

        var firstActivate = function () {
            findItems(0);
            activateStub();
        }

        /**
         * инициализация плагина
         * */
        var init = function () {
            $calculateButton.each(function (index, item) {
                $(this).on('click', function () {
                    var buttonIndex = index;
                    findItems(buttonIndex);
                    activateStub();
                });
            });
            firstActivate();
        };

        if (window.innerWidth < widthForInit) {
            init();
        }
        return this;
    };
    $('.js-stub').each(function () {
        $(this).data('activateSimpleStub', $(this).activateSimpleStub());
    });
})(jQuery);
